import { CalendarDays, Save, Settings, ShieldCheck } from "lucide-react";
import { PageHeader } from "../../components/PageHeader";

export function SettingsPage() {
  return (
    <div className="grid gap-8">
      <PageHeader
        eyebrow="Client Settings"
        title="Vault settings for upload access and ownership."
        subtitle="Use these fields as the reusable template controls for each Memory Hub client and event."
      />
      <section className="grid gap-6 lg:grid-cols-[1fr_.8fr]">
        <form className="ivory-card rounded-lg p-6 sm:p-8">
          <Settings className="size-8 text-[#D94A16]" />
          <h2 className="mt-5 font-display text-3xl font-bold">Event Settings</h2>
          <div className="mt-6 grid gap-4">
            <label className="grid gap-2 text-sm font-bold">
              Upload status
              <select className="focus-ring rounded-lg border border-ktd-gold/25 bg-white px-4 py-3">
                <option>Open</option>
                <option>Closed</option>
              </select>
            </label>
            <label className="grid gap-2 text-sm font-bold">
              Upload deadline
              <input type="date" className="focus-ring rounded-lg border border-ktd-gold/25 bg-white px-4 py-3" />
            </label>
            <label className="grid gap-2 text-sm font-bold">
              Client notes
              <textarea
                rows={5}
                className="focus-ring rounded-lg border border-ktd-gold/25 bg-white px-4 py-3"
                placeholder="Private client notes for support or event preferences"
              />
            </label>
            <button
              type="button"
              className="focus-ring inline-flex items-center justify-center gap-2 rounded-lg bg-ktd-black px-5 py-3 text-sm font-extrabold text-ktd-softGold"
            >
              <Save className="size-4" />
              Save Settings
            </button>
          </div>
        </form>

        <aside className="grid gap-6">
          <article className="rounded-lg bg-ktd-black p-6 text-white shadow-luxe">
            <CalendarDays className="size-8 text-ktd-softGold" />
            <h2 className="mt-5 font-display text-3xl font-bold">Upload deadline setting</h2>
            <p className="mt-4 text-sm leading-6 text-white/64">
              The backend checks upload_status and upload_deadline before accepting guest uploads.
            </p>
          </article>
          <article className="ivory-card rounded-lg p-6">
            <ShieldCheck className="size-8 text-[#D94A16]" />
            <h2 className="mt-5 font-display text-3xl font-bold">Storage Ownership Notice</h2>
            <p className="mt-4 text-sm leading-6 text-ktd-muted">
              This Memory Media Vault is connected to a client-owned Cloudflare account. The client is responsible for
              keeping Cloudflare billing active, maintaining login access, and keeping a personal backup of all original
              photos and videos. Kreatethedate configures and manages the Memory Hub connection while services are
              active.
            </p>
          </article>
        </aside>
      </section>
    </div>
  );
}
